import { getApiFeaturemanagementIsstripepaymentenabled } from "./getApiFeaturemanagementIsstripepaymentenabled";

export function featureManagementController() {
  return { getApiFeaturemanagementIsstripepaymentenabled };
}
